import {
  GET_ALL_BANNERS,
  GET_ALL_BANNERS_RESPONSE_SUCCESS,
  CREATE_BANNER,
  UPDATE_BANNER,
  DELETE_BANNER,
} from "./actionTypes"

export const getAllBanners = () => {
  return {
    type: GET_ALL_BANNERS,
  }
}
export const getAllBannersResponseSuccess = payload => ({
  type: GET_ALL_BANNERS_RESPONSE_SUCCESS,
  payload: payload,
})

// ------------------------------------- CREATE --------------------------------------------------------

export const createBanner = (payload, history) => {
  return {
    type: CREATE_BANNER,
    payload: payload,
    history,
  }
}

// ------------------------------------- EDIT --------------------------------------------------------

export const updateBanner = (payload, history, id) => {
  return {
    type: UPDATE_BANNER,
    payload: payload,
    history,
    id,
  }
}

// ------------------------------------- DELETE --------------------------------------------------------

export const deleteBanner = payload => ({
  type: DELETE_BANNER,
  payload: payload,
})
